<script>
	// NPM Modules
	import { flip } from 'svelte/animate';
	// Stores
	import MultiExpressGroupStore from '@/Stores/MultiExpressGroupStore.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	// Partials
	import MultiExpressGroups from '@/Partials/MultiExpress/_MultiExpressGroups.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	let sending = false;

	$: loading = MultiExpressGroupStore.getMultiExpressGroups();
	$: multiExpressGroup = $MultiExpressGroupStore;
	$: canSaveOrder = multiExpressGroup && !checkIfUncreatedMultiExpressGroup(multiExpressGroup);
	$: firstOrderId = multiExpressGroup && multiExpressGroup.min('order');
	$: lastOrderId = multiExpressGroup && multiExpressGroup.max('order');

	function onAddMultiExpressGroup() {
		MultiExpressGroupStore.addNewMultiExpressGroupToStore();
	}

	function checkIfUncreatedMultiExpressGroup(multiExpressGroup) {
		let uncreatedMultiExpressGroup = false;
		multiExpressGroup.each((multiExpressGroup) => {
			if (multiExpressGroup.temp_id) {
				uncreatedMultiExpressGroup = true;
				return false;
			}
		});
		return uncreatedMultiExpressGroup;
	}

	async function saveMultiExpressGroupOrder() {
		let saveOrderOperations = [];
		let counter = 1;

		sending = true;

		multiExpressGroup.sortBy('order').transform((multiExpressGroup) => {
			multiExpressGroup.order = counter++;
			return multiExpressGroup;
		});
		multiExpressGroup.each((multiExpressGroup) => {
			const promise = new Promise((resolve, reject) => {
				MultiExpressGroupStore.saveMultiExpressGroupOrder(multiExpressGroup)
					.then(() => {
						resolve();
					})
					.catch((error) => {
						reject(error);
					});
			});
			saveOrderOperations.push(promise);
		});
		Promise.all(saveOrderOperations)
			.then(() => {
				notify({
					type: 'success',
					title: 'Multi express group',
					message: 'Multi express group order updated successfully',
					timeout: 3
				});
				MultiExpressGroupStore.getMultiExpressGroups();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update Multi express group order',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center justify-between w-full">
					<h1 class="text-xl font-bold">Multi Express</h1>
				</div>
			</div>
			<!-- /Page Header -->
			{#if multiExpressGroup}
				<div class="p-2 mx-auto bg-gray-100 rounded max-w-custom">
					<div class="mt-2 rounded">
						<div class="space-y-2">
							<div>
								<div class="flex mb-2">
									<div class="flex flex-row justify-between w-full">
										<div>
											{#if multiExpressGroup && multiExpressGroup.count() > 0}
												<button
													on:click={() => saveMultiExpressGroupOrder(multiExpressGroup.id)}
													disabled={!canSaveOrder || sending}
													class="btn btn-primary"
													class:opacity-50={!canSaveOrder}
												>
													Save Order
												</button>
											{/if}
											<button on:click={() => onAddMultiExpressGroup()} class="btn btn-primary-action text-tiny ml-2">
												Add Multi Express Group
											</button>
										</div>
									</div>
								</div>
								<div class="relative">
									<div class="space-y-2 list">
										{#each multiExpressGroup
											.sortBy('order')
											.all() as multiExpressGroup (multiExpressGroup.id ?? multiExpressGroup.temp_id)}
											<div class="item" data-order={multiExpressGroup.order} animate:flip={{ duration: 200 }}>
												<svelte:component
													this={MultiExpressGroups}
													{multiExpressGroup}
													first={firstOrderId}
													last={lastOrderId}
												/>
											</div>
										{/each}
									</div>
								</div>
							</div>
							<div class="py-2 mb-4 border-b" />
						</div>
					</div>
				</div>
			{/if}
		</div>
	{/await}
</div>
